import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TrackingScreen, TrackingSubscreen, trackFavoriteRolloutButtonClick } from '../../../app/utils/tracking';
import FavoriteRolloutIcon from '../FavoriteRolloutIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const FavoriteIconWrapper = styled.div.withConfig({
  displayName: "FavoriteRolloutButton__FavoriteIconWrapper",
  componentId: "sc-1eimlr8-0"
})(["display:flex;align-items:center;justify-content:center;padding-block-start:", ";"], ({
  theme
}) => theme.space['100']);
export function FavoriteRolloutButton({
  productUpdateId,
  productUpdateTitle,
  rolloutId,
  initialIsFavorite
}) {
  return /*#__PURE__*/_jsx(FavoriteIconWrapper, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: initialIsFavorite ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.removeFavorite"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.addFavorite"
      }),
      children: /*#__PURE__*/_jsx(FavoriteRolloutIcon, {
        size: "500",
        rolloutId: rolloutId,
        productUpdateId: productUpdateId,
        productUpdateTitle: productUpdateTitle,
        isFavorite: initialIsFavorite,
        isPUHovered: false,
        alwaysShowIcon: true,
        onAddCompletedCb: () => {
          trackFavoriteRolloutButtonClick({
            screen: TrackingScreen.PRODUCT_UPDATES,
            subscreen: TrackingSubscreen.UPDATE_PANEL,
            origin: 'panel',
            productUpdateId: `${productUpdateId}`,
            action: 'add favorite'
          });
        },
        onRemoveCompletedCb: () => {
          trackFavoriteRolloutButtonClick({
            screen: TrackingScreen.PRODUCT_UPDATES,
            subscreen: TrackingSubscreen.UPDATE_PANEL,
            origin: 'panel',
            productUpdateId: `${productUpdateId}`,
            action: 'remove favorite'
          });
        }
      })
    })
  });
}